<template>
	<div id="app">
		<meta name="referrer" content="no-referrer" />
		<!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
		</keep-alive>-->
		<keep-alive include="Phone">
			<router-view />
		</keep-alive>
	</div>
</template>
<script>
import { firmLogo } from './api/home'
export default {
	name: 'App',
	data() {
		return {}
	},
	methods: {},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				firmLogo(localStorage.getItem('firmId')).then((res) => {
					localStorage.setItem(
						'firmLogo',
						res.data
							? res.data
							: 'https://fw.guoli315.com/img/logo.png'
					)
				})
			}, 2000)
		})
	},
}
</script>

<style>
* {
	margin: 0;
	padding: 0;
	list-style: none;
	border: none;
	scrollbar-width: none; /* firefox */
	-ms-overflow-style: none; /* IE 10+ */
}
body,
html {
	width: 100vw;
	min-height: 100% !important;
	overflow-x: hidden;
	overflow-y: auto;
	scrollbar-width: none; /* firefox */
	-ms-overflow-style: none; /* IE 10+ */
}
#app {
	min-height: 100%;
	scrollbar-width: none; /* firefox */
	-ms-overflow-style: none; /* IE 10+ */
}

/* vant滑动删除样式 */
.delete-button {
	width: 1.4rem !important;
	background: rgba(255, 103, 69, 1) !important;
	height: 100% !important;
	border: 1px solid rgba(255, 103, 69, 1) !important;
	font-size: 0.32rem !important;
	font-family: PingFangSC-Regular, PingFang SC !important;
	font-weight: 400 !important;
	color: rgba(255, 255, 255, 1) !important;
}
/* vanr组件去掉底部线 */
.van-cell::after {
	border-bottom: none !important;
}
.van-field__control::placeholder {
	color: rgba(216, 216, 216, 1) !important;
	flex-wrap: 500 !important;
	background: #fff !important;
}
/* vant提示框 */
.van-dialog {
	width: 80% !important;
}
.van-cell {
	padding: 0rem !important;
	background: #869ac2 !important;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
	border-width: 0 !important;
}
.van-collapse-item--border::after {
	border-top: none !important;
}
.van-collapse-item__content {
	padding: 0 !important;
	background: none !important;
}
.van-cell__left-icon,
.van-cell__right-icon {
	display: none !important;
}
.van-cell__title {
	width: 100% !important;
	height: 0.96rem;
	background: rgba(134, 154, 194, 1) !important;
	text-align: center !important;
	line-height: 0.96rem !important;
	font-size: 0.26rem !important;
	font-family: PingFangSC-Regular, PingFang SC !important;
	font-weight: 400 !important;
	color: rgba(255, 255, 255, 1) !important;
}
/* vant步进器 */
.van-stepper {
	border: 0.02rem solid #dadada !important;
	box-sizing: border-box !important;
}
.van-stepper__minus--disabled,
.van-stepper__plus--disabled {
	width: 0.59rem !important;
	background-color: #ffffff !important;
	box-sizing: border-box !important;
	border-right: 0.02rem solid #dadada !important;
}
.van-stepper__input {
	width: 0.8rem !important;
	background-color: #ffffff !important;
	box-sizing: border-box !important;
	border-right: 0.02rem solid #dadada !important;
	margin: 0 !important;
	padding: 0 !important;
}
.van-stepper__minus,
.van-stepper__plus {
	width: 0.56rem !important;
	background-color: #ffffff !important;
}
.van-stepper__minus {
	border-right: 0.02rem solid #dadada !important;
}
/* .van-field__control{
  color: #636363!important;
  background-color: #FFF!important;
  border-radius: 0px!important;
} */
.van-field__control {
	color: #636363 !important;
	background-color: #fff !important;
	border-radius: 0px !important;
	outline: none !important  ;
	border: none !important ;
	padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue